import React, { Component } from 'react'
import ButtonLinkExternal from '../generic/ButtonLinkExternal'

class WebMailHelper extends Component {
	render() {
		const { event, guests, body, subject } = this.props

		const mail = {
      to: guests ? guests.map((guest) => encodeURIComponent(guest.email)).join(",") : "",
      subject: subject || "An invitation to my On the Table event",
      body: body || '',
    }

		return (
			<div>
        <ButtonLinkExternal small="true" secondary="true" href={`mailto:${mail.to}?subject=${mail.subject}&body=${mail.body}`} style={{margin: '0 16px 12px 0'}}>Use Your Computer's Mail App</ButtonLinkExternal>
        <ButtonLinkExternal small="true" secondary="true" href={`https://outlook.live.com/default.aspx?rru=compose&to=${mail.to}&subject=${mail.subject}&body=${mail.body}`} target="_blank" style={{margin: '0 16px 12px 0'}}>Use Hotmail/Outlook/Live Mail</ButtonLinkExternal>
        <ButtonLinkExternal small="true" secondary="true" href={`https://mail.google.com/mail/?view=cm&fs=1&to=${mail.to}&su=${mail.subject}&body=${mail.body}`} target="_blank" style={{margin: '0 16px 12px 0'}}>Use Gmail</ButtonLinkExternal>
        <ButtonLinkExternal small="true" secondary="true" href={`http://compose.mail.yahoo.com/?to=${mail.to}&subj=${mail.subject}&body=${mail.body}`} target="_blank" style={{margin: '0 16px 12px 0'}}>Use Yahoo! Mail</ButtonLinkExternal>
      </div>
		)
	}
}

export default WebMailHelper